import {Component, Input, OnInit} from "@angular/core";
import {UserService} from "../../../common/user.service";
import {ILocaleProperties} from "../../../locale/locale-models";
import {ShippingService} from "../../../shipping/shipping.service";
import {BaseComponent} from "../../../base.component";
import {LoggerService} from "../../../common/logger.service";
import {BsModalRef} from "ngx-bootstrap/modal";
import {Constants} from "../../../constants";
import * as _ from "lodash";
import {LocaleSwitcherService} from "../../../locale/locale-switcher.service";

@Component({
    selector: 'social-welcome',
    templateUrl: './social-welcome.component.html',
    styleUrls: ['./social-welcome.component.scss'],
    standalone: false
})
export class SocialWelcomeComponent extends BaseComponent implements OnInit {

    currentLocaleData: ILocaleProperties;
    showLocalesPicker: boolean = false;
    freeShippingMsg: string;
    welcomeMessage: string;
    confirmLocale: ILocaleProperties;

    @Input() public showAddToCart;
    @Input() shareId: string;
    @Input() customerType: string;
    @Input() freeShippingEligible: boolean;

    constructor(
        public bsModalRef: BsModalRef,
        loggerService: LoggerService,
        private userService: UserService,
        private shippingService: ShippingService,
        private localeSwitcherService: LocaleSwitcherService
    ) {
        super(userService, loggerService);
    }

    ngOnInit() {
        this.getWelcomeMessage();
        if (this.freeShippingEligible) {
            this.getFreeShippingMessage();
        }
    }

    onCurrentLocaleData(data: any) {
        this.currentLocaleData = data;
    }

    getWelcomeMessage() {
        if (this.showAddToCart) {
            this.welcomeMessage = "cart.shareable.welcome.body.text";
        } else if (this.shareId === Constants.SHARE_NAME_AFFILIATE_SIGNUP) {
            this.welcomeMessage = "cart.shareable.affiliate.welcome.body.text";
        } else if (this.shareId === Constants.SHARE_NAME_ASSOCIATE_SIGNUP) {
            this.welcomeMessage = "cart.shareable.associate.welcome.body.text";
        } else {
            this.welcomeMessage = "cart.shareable.generic.welcome.body.text";
        }
    }

    getFreeShippingMessage() {
        this.freeShippingMsg = undefined;
        this.shippingService.getFirstTimeMessage(this.customerType).then(message =>
            this.freeShippingMsg = message
        , () => this.freeShippingMsg = undefined);
    }

    onLocaleChange(locale: ILocaleProperties) {
        this.localeSwitcherService.changeLocale(locale.usanaLocale);
    }

    confirmClicked() {
        this.confirmLocale = _.cloneDeep(this.currentLocaleData);
    }
}

